import React, { useEffect, useContext } from "react"
import { Grid, Typography } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import SkywatchInformationTooltip from "../../Core/Popover/SkywatchInformationTooltip";
import {  NumberedTextField } from "../../Core/Form/ControlledFields";
import { ReactComponent as CurrencyIcon} from '../../../assets/dollar-sign.svg';
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";

const InsuredValueField = () => {
    const { watch, setValue } = useFormContext();
    const min = watch("min_value")
    const max = watch("max_value")
    const allowHull = watch("allow_hull");
    const {locked_quote} = useContext(QuoteContextStore)
    useEffect(() => {
        if(allowHull) return;
        setValue("value", "")
    }, [allowHull])
    return (<>
        <Grid container wrap="nowrap" justifyContent="space-between">
            <Grid item>
                <SkywatchInformationTooltip text="If you enter an Insured Value outside the indicated range, your application will require further review. The maximum allowed insured value is $550,000" placement="bottom">
                    <Typography variant="h4" className="gray">Insured value</Typography>
                </SkywatchInformationTooltip>
            </Grid>
            <Grid item>
                <Typography variant="h4" className="gray">
                    {'('}
                    <span>
                        {min
                            ? '$' +
                            min.toLocaleString('en-US')
                            : '$0 '}
                    </span>
                    {' - '}
                    <span>
                        {max
                            ? max.toLocaleString('en-US')
                            : '550,000'}
                    </span>
                    {')'}
                </Typography>
            </Grid>
        </Grid>
        <NumberedTextField fullWidth name="value" disabled={!allowHull} className="margin-top-8 padding-top-3 padding-bottom-3"  isIconAtStart IconComponent={CurrencyIcon} disabled={locked_quote}/>               
    </>
    );
}

export default InsuredValueField